import React, { useEffect, useState } from 'react';
import { Modal, Text, Field, TextField, ActionButton } from 'components/commons';
import styles from './transaction-status-modal.module.scss'; // reuse styles for visual consistency
import { Grid } from '@material-ui/core';

const PrintPassbookModal = ({ active, close, onConfirm }) => {
  const [range, setRange] = useState({ from: '', to: '', start: '' });
  const [errorRange, setErrorRange] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (name, { value }) => {
    setRange((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    if (active) {
      setRange({ from: '', to: '', start: '' });
      setErrorRange(null);
      setError(null);
    }
  }, [active]);

  const handleConfirm = () => {
    const from = parseInt(range.from, 10);
    const to = parseInt(range.to, 10);
    const start = parseInt(range.start, 10);

    if (isNaN(from) || isNaN(to) || from <= 0 || to <= 0 || from > to) {
      setErrorRange('Please enter a valid range (e.g., From 1 to 10).');
      return;
    }

    if (isNaN(start) || start > 35 || (start >= 35 && to - from > 1)) {
      setError('Max. rows to print is 35. Please enter a valid starting row.');
      return;
    }

    onConfirm({ from, to, start });
    close();
  };

  return (
    <Modal active={active} title="Print Passbook Range" close={close} className={styles.modal}>
      <div className={styles.content}>
        <Text>Enter the range of transaction rows you want to print.</Text>

        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} sm={4}>
            <Field label="Start Row" error={errorRange !== null || error !== ''} message={errorRange}>
              <TextField name="from" placeholder="e.g. 1" value={range.from} onChange={handleChange} type="number" />
            </Field>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Field label="End Row">
              <TextField name="to" placeholder="e.g. 10" value={range.to} onChange={handleChange} type="number" />
            </Field>
          </Grid>
        </Grid>

        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} sm={4}>
            <Field label="Beginning Row to Print" error={error !== null || error !== ''} message={error}>
              <TextField name="start" placeholder="e.g. 1" value={range.start} onChange={handleChange} type="number" />
            </Field>
          </Grid>
        </Grid>
      </div>

      <ActionButton
        right
        items={[
          {
            text: 'Cancel',
            onClick: close
          },
          {
            text: 'Print',
            onClick: handleConfirm
          }
        ]}
      />
    </Modal>
  );
};

export default PrintPassbookModal;
